/* Real product pages: edit these handles to match your Shopify products.
   Any link to #flavors / #original / #supergreen / #bundles / #bottle routes here. */
var PRODUCT_URLS = {
  flavors:    '/products/energyze-moringa-flavored-powder-100g',
  original:   '/products/energyze-moringa-powder-original',
  supergreen: '/products/energyze-supergreen',
  bundles:    '/products/the-all-in-bundle-3-flavors-available',
  bottle:     '/products/energyze-500-ml-plastic-pba-bottles'
};
function openNav(){ document.body.classList.add('nav-open'); }
function closeNav(){ document.body.classList.remove('nav-open'); }
function go(page){
    closeNav();
    if(PRODUCT_URLS[page]){ window.location.href = PRODUCT_URLS[page]; return; }
    document.querySelectorAll('main[id^="page-"]').forEach(m=>m.classList.remove('active'));
    var el=document.getElementById('page-'+page);
    if(el){el.classList.add('active')}
    /* home = the index sections in #MainContent; any other page hides it and shows its store page */
    document.body.classList.toggle('subpage', page!=='home' && !!el);
    document.querySelectorAll('[data-nav]').forEach(a=>a.classList.toggle('active',a.dataset.nav===page));
    window.scrollTo({top:0});
    var sticky=document.getElementById('stickyAtc');
    sticky.classList.toggle('show', page==='flavors'||page==='original'||page==='supergreen'||page==='bundles'||page==='whatis'||page==='vsmatcha'||page==='bloatguide'||page==='metaguide');
    if(page==='metaguide'){
      document.getElementById('stickyTitle').textContent='Energyze Flavored — the steady-energy ritual in this guide';
      document.getElementById('stickyPrice').textContent='From $29.99 · 0 caffeine · Health-First Guarantee';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg';
    } else if(page==='bloatguide'){
      document.getElementById('stickyTitle').textContent='Energyze Flavored — the de-bloat ritual in this guide';
      document.getElementById('stickyPrice').textContent='From $29.99 · 3 flavors · Health-First Guarantee';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg';
    } else if(page==='vsmatcha'){
      document.getElementById('stickyTitle').textContent='Energyze Original — the matcha alternative in this article';
      document.getElementById('stickyPrice').textContent='From $19.99 · zero caffeine · Health-First Guarantee';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp';
    } else if(page==='whatis'){
      document.getElementById('stickyTitle').textContent='Energyze Original Moringa — the powder in this article';
      document.getElementById('stickyPrice').textContent='From $19.99 · Health-First Guarantee';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp';
    } else if(page==='bundles'){
      document.getElementById('stickyTitle').textContent='The Energyze Bundle';
      document.getElementById('stickyPrice').textContent='$75.00 · 2 Bundles';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Digestion_bundle_main_image.jpg';
    } else if(page==='supergreen'){
      document.getElementById('stickyTitle').textContent='Energyze 21 Ingredients Supergreen';
      document.getElementById('stickyPrice').textContent='$59.99 · 2 Months Supply';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-super-green-powder-bowl-and-drink-flatlay.png';
    } else if(page==='original'){
      document.getElementById('stickyTitle').textContent='Energyze Original Moringa Powder';
      document.getElementById('stickyPrice').textContent='$19.99';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp';
    } else {
      document.getElementById('stickyTitle').textContent='Energyze Flavored Moringa';
      document.getElementById('stickyPrice').textContent='$49.97 · 3 Packs';
      document.getElementById('stickyImg').src='https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg';
    }
  }
  function pickTier(el,n){
    var siblings = el.parentElement.querySelectorAll('.tier');
    siblings.forEach(t=>t.classList.remove('on'));
    el.classList.add('on');
    var slots = el.parentElement.querySelector('.slots');
    if(slots){
      Array.from(slots.children).forEach((s,i)=>{ s.style.display = i < n ? 'flex' : 'none'; });
      var btn = el.parentElement.querySelector('.btn--wide');
      var filled = Array.from(slots.children).slice(0,n).filter(s=>s.classList.contains('filled')).length;
      var prices = {1:'$29.99',2:'$39.99',3:'$49.97'};
      if(btn){ btn.textContent = filled < n ? 'Select your flavors ('+filled+'/'+n+')' : 'Add '+n+' to Cart — '+prices[n]; }
    }
  }
  function swapImg(thumb, mainId){
    document.getElementById(mainId).src = thumb.src;
    thumb.parentElement.querySelectorAll('img').forEach(i=>i.classList.remove('on'));
    thumb.classList.add('on');
  }
  /* ==================== SHOP ENGINE: products, metafield upsells, cart ==================== */
  var IMG = {
    flavored:'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg',
    original:'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp',
    supergreen:'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-super-green-powder-bowl-and-drink-flatlay.png',
    bundle:'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Digestion_bundle_main_image.jpg',
    bottle:'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-500-ml-tritan-bottle-1995483.png'
  };
  var PRODUCTS = {
    flavored: { title:'Flavored Moringa', img:IMG.flavored, tag:'MOST POPULAR', tagClass:'pill--gold', popular:true,
      forLine:'The moringa ritual — made delicious', stars:'4.5 (237)',
      checks:['Tastes like juice — ~12 kcal','Debloat + steady energy','Mango · Lemon · Strawberry'],
      tiers:[ {label:'1 Month Supply', sub:'25 servings of 4 grams each', price:29.99, was:39.99},
              {label:'2 Months Supply', offer:'BUY 1 GET THE 2ND FOR 75% OFF', badge:'MOST LOVED', badgeClass:'qb-badge--gut', price:39.99, was:59.98},
              {label:'3 Months Supply', offer:'BUY 2 GET 1 FREE', badge:'90-DAY GUT RESET', badgeClass:'qb-badge--gut', price:49.97, was:89.97} ], defTier:2 },
    original: { title:'Original Powder', img:IMG.original, tag:'', popular:false,
      forLine:'The moringa ritual — 100% pure', stars:'4.5 (412)',
      checks:['100% pure single ingredient','90+ nutrients · 9 amino acids','Lowest cost per serving'],
      tiers:[ {label:'1 Month Supply', sub:'25 servings of 2 grams each', price:19.99},
              {label:'2 Months Supply', offer:'2 BAGS FOR $25 — 2ND BAG 75% OFF', badge:'MOST POPULAR', badgeClass:'qb-badge--pop', price:24.99, was:39.98},
              {label:'3 Months Supply', offer:'3 BAGS FOR $30 — SAVE 50%', badge:'90-DAY GUT RESET', badgeClass:'qb-badge--gut', price:29.99, was:59.97} ], defTier:1 },
    supergreen: { title:'21-Ingredient Supergreen', img:IMG.supergreen, tag:'PERFECT PAIR', tagClass:'', popular:false,
      forLine:'The perfect add-on to your moringa', stars:'4.5 (66)',
      checks:['Pairs with any moringa ritual','Gut, immunity & energy in one','21 superfoods in a single scoop'],
      tiers:[ {label:'1 Month Supply', sub:'30 servings of 5 grams each', offer:'BUY 1 FOR $40', price:39.99},
              {label:'2 Months Supply', offer:'BUY 1 GET THE 2ND 50% OFF', badge:'MOST POPULAR', badgeClass:'qb-badge--pop', price:59.99, was:79.98},
              {label:'3 Months Supply', offer:'BUY 2 GET 1 FREE', badge:'90-DAY GUT RESET', badgeClass:'qb-badge--gut', price:79.99, was:119.97} ], defTier:1 },
    bundle: { title:'The All-In Bundle', img:IMG.bundle,
      tiers:[ {label:'1 Bundle', price:49.97, was:89.97} ], defTier:0 },
    bottle: { title:'Energyze Shaker Bottle', img:IMG.bottle,
      upsellNote:'BPA-free Tritan 500ml', unit:8.99, was:11.99 }
  };
  /* metafield-style upsell map — mirrors product.metafields.cart.upsell in the theme.
     Rule: flavored in cart <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> bottle (discount) + supergreen (full price) + original (30% OFF) */
  var UPSELL_METAFIELDS = {
    flavored:['bottle','supergreen','original'],
    original:['bottle','flavored','supergreen'],
    supergreen:['bottle','flavored','original'],
    bundle:['bottle','supergreen','original'],
    bundlekit:['supergreen','flavored','bottle'],
    bottle:['flavored','supergreen','original']
  };
  /* Upsell pricing is a percentage LADDER driven by what's actually selected (fixed bag/kit lines):
       base < $29.97  <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> full price (bottle $11.99, original $19.99, supergreen $39.99)
       base ≥ $29.97  <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> 20% OFF every upsell   (1 bag selected — holds through $40)
       base ≥ $50.00  <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> 30% OFF every upsell */
  var UPSELL_PRICES = {
    bottle:{full:11.99},
    original:{full:19.99},
    flavored:{full:29.99},
    supergreen:{full:39.99}
  };
  function upsellRate(){
    var base = cart.reduce(function(s,l){ return s + (l.fixed ? l.total : 0); },0);
    return base >= 49.97 ? 0.30 : (base >= 29.97 ? 0.20 : 0); /* 49.97 so the flagship 3-packs & bundle qualify */
  }
  function upDisc(full, rate){ return Math.round(full*(1-rate)*100)/100; }

  var cart = [];            /* lines: {key,id,title,img,label,qty,total,unit,fixed} */
  try { var __saved = JSON.parse(localStorage.getItem('ezb_cart') || '[]'); if (__saved && __saved.length) cart = __saved; } catch(e) {}
  var tierSel = { flavored:2, original:1, supergreen:1, bundle:0 };

  function fmt(n){ return n.toFixed(2) + ' USD'; }

  var RIT_ITEMS = ['flavored','original','supergreen'];
  function renderCarousel(){
    var el = document.getElementById('ritCarousel');
    if(!el) return;
    if(el.dataset.static === '1') return; /* products rendered by Liquid blocks — leave them alone */
    el.innerHTML = RIT_ITEMS.map(function(id){
      var p = PRODUCTS[id];
      var tiers = p.tiers.map(function(t,i){
        return '<div class="qb-row'+(tierSel[id]===i?' on':'')+'" onclick="pickQb(\''+id+'\','+i+')">'
          +(t.badge?'<span class="qb-badge '+t.badgeClass+'">'+t.badge+'</span>':'')
          +'<span class="qb-dot"></span>'
          +'<span class="qb-main"><span class="qb-label">'+t.label+'</span>'
          +(t.offer?'<span class="qb-offer">'+t.offer+'</span>':'')
          +(t.sub?'<span class="qb-sub">'+t.sub+'</span>':'')+'</span>'
          +'<span class="qb-price">'+fmt(t.price)+(t.was?'<span class="qb-was">'+fmt(t.was)+'</span>':'')+'</span></div>';
      }).join('');
      var sel = p.tiers[tierSel[id]];
      return '<div class="rit-card'+(p.popular?' popular':'')+'">'
        +(p.tag?'<span class="rit-tag pill '+(p.tagClass||'')+'">'+p.tag+'</span>':'')
        +'<img src="'+p.img+'" alt="'+p.title+'">'
        +'<div class="rit-body">'
        +'<span class="rit-for">'+p.forLine+'</span><h3>'+p.title+'</h3>'
        +'<div class="rit-stars"><span class="stars"><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg></span> '+p.stars+'</div>'
        +'<ul class="rit-checks">'+p.checks.map(function(c){return '<li>'+c+'</li>';}).join('')+'</ul>'
        +'<p class="qb-head">Buy More, Save More</p>'
        +'<div class="qb">'+tiers+'</div>'
        +'<button class="btn btn--wide rit-atc" onclick="cartAddTier(\''+id+'\')">Add to Cart — '+fmt(sel.price)+'</button>'
        +'</div></div>';
    }).join('');
  }
  function pickQb(id,i){ tierSel[id]=i; renderCarousel(); }
  var ritTimer = null, ritIdx = 0;
  function ritScroll(dir){
    var el = document.getElementById('ritCarousel');
    if(!el) return;
    var n = el.children.length || RIT_ITEMS.length;
    ritIdx = (ritIdx + dir + n) % n;
    el.scrollTo({left: ritIdx * 356, behavior:'smooth'});
    clearInterval(ritTimer); ritTimer = null; /* manual arrows permanently disable auto-scroll */
  }
  function ritAuto(){
    clearInterval(ritTimer);
    ritTimer = setInterval(function(){
      var el = document.getElementById('ritCarousel');
      if(!el) return;
      var host = el.closest('main');
      if(host && host.id !== 'MainContent' && !host.classList.contains('active')) return;
      if(host && host.id === 'MainContent' && document.body.classList.contains('subpage')) return;
      var n = el.children.length || RIT_ITEMS.length;
      ritIdx = (ritIdx + 1) % n;
      el.scrollTo({left: ritIdx * 356, behavior:'smooth'});
    }, 15000);
  }
  ritAuto();

  /* initialise variant slots + ATC price for Liquid-rendered product cards */
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.rit-card').forEach(function(card){
      var row = card.querySelector('.qb-row.on') || card.querySelector('.qb-row');
      if(row && typeof ritQbPick === 'function') ritQbPick(row);
      else if(typeof ritRenderSlots === 'function') ritRenderSlots(card);
    });
  });

  /* research-benefits carousel: auto-advance every 10s; arrows kill autoplay */
  /* research carousel: 2 slides of 2 cards each; auto-advances every 8s; arrows stop autoplay */
  var benTimer = null, benPage = 0;
  function benPer(){ return window.innerWidth < 861 ? 1 : 2; }
  function benPages(){
    var el = document.getElementById('benCarousel');
    var n = el ? el.querySelectorAll('.ben-card').length : 4;
    return Math.max(1, Math.ceil(n / benPer()));
  }
  function benPageW(){
    var el = document.getElementById('benCarousel');
    var card = el && el.querySelector('.ben-card');
    return card ? (card.offsetWidth + 16) * benPer() : 640;
  }
  function benGo(){
    var el = document.getElementById('benCarousel');
    if(el) el.scrollTo({left: benPage * benPageW(), behavior:'smooth'});
  }
  function benScroll(dir){
    benPage = (benPage + dir + benPages()) % benPages();
    benGo();
    clearInterval(benTimer); benTimer = null; /* manual arrows permanently stop auto-slide */
  }
  (function benAuto(){
    benTimer = setInterval(function(){
      var el = document.getElementById('benCarousel');
      if(!el || !el.closest('main').classList.contains('active')) return;
      benPage = (benPage + 1) % benPages();
      benGo();
    }, 8000);
  })();

  /* supergreen percentage circles: ring draws + number counts up on scroll into view */
  (function(){
    var CIRC = 2*Math.PI*76;
    document.querySelectorAll('.pc-ring').forEach(function(ring){
      var run = function(){
        var pct = parseInt(ring.dataset.pct,10);
        var bar = ring.querySelector('.bar');
        var num = ring.querySelector('.pc-num');
        bar.style.strokeDashoffset = (CIRC * (1 - pct/100)).toFixed(1);
        var t0=null, DUR=1600;
        function tick(ts){
          if(!t0) t0=ts;
          var p=Math.min((ts-t0)/DUR,1), eased=1-Math.pow(1-p,3);
          num.textContent = Math.round(pct*eased)+'%';
          if(p<1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es,obs){
          es.forEach(function(e){ if(e.isIntersecting){ run(); obs.disconnect(); } });
        },{threshold:.45}).observe(ring);
      } else run();
    });
  })();

  /* reveal-on-scroll for listicle content */
  (function(){
    var els = document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in'); }); return; }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); obs.unobserve(en.target); } });
    },{threshold:.12});
    els.forEach(function(e){ obs.observe(e); });
  })();

  /* scroll-triggered animations: nutrient bars fill + 10,000 counter */
  (function(){
    var bars = document.querySelector('.nutribars');
    if(bars && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries, obs){
        entries.forEach(function(en){
          if(en.isIntersecting){ bars.classList.add('nb-go'); obs.disconnect(); }
        });
      }, {threshold:.25}).observe(bars);
    } else if(bars){ bars.classList.add('nb-go'); }

    document.querySelectorAll('.rev-count[data-target]').forEach(function(counter){
      var run = function(){
        var target = parseInt(counter.dataset.target,10), t0 = null, DUR = 1800;
        function tick(ts){
          if(!t0) t0 = ts;
          var p = Math.min((ts - t0)/DUR, 1);
          var eased = 1 - Math.pow(1-p, 3);
          counter.textContent = Math.round(target*eased).toLocaleString('en-US') + '+';
          if(p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries, obs){
          entries.forEach(function(en){ if(en.isIntersecting){ run(); obs.disconnect(); } });
        }, {threshold:.4}).observe(counter);
      } else run();
    });
  })();

  /* The All-In Bundle is a KIT: in cart it shows as Flavored (choose flavor) + Original + FREE bottle */
  var bundleFlavorSel = 'Mango';
  function bundleFlavor(f){
    bundleFlavorSel = f;
    var l = cart.find(function(x){ return x.key==='bundle-flavored'; });
    if(l){
      l.label = 'Flavor: '+f+' · All-In Bundle';
      l.flavors = [f];
      var fo = (typeof FLAVORS!=='undefined') && FLAVORS.find(function(x){ return x.name===f; });
      if(fo) l.img = fo.img; /* line image follows the chosen flavor */
    }
    renderCart();
  }
  function cartAddTier(id){
    if(id==='bundle'){
      cart = cart.filter(function(l){ return !l.bundle; });
      cart.push({key:'bundle-flavored', id:'flavored', bundle:'allin', fixed:true, title:'Flavored Moringa', img:IMG.flavored, label:'Flavor: '+bundleFlavorSel+' · All-In Bundle', flavors:[bundleFlavorSel], qty:1, total:29.99, was:39.99});
      cart.push({key:'bundle-original', id:'original', bundle:'allin', fixed:true, title:'Original Powder', img:IMG.original, label:'All-In Bundle', qty:1, total:19.98, was:null});
      cart.push({key:'bundle-bottle', id:'bottle', bundle:'allin', fixed:true, title:'Energyze Shaker Bottle', img:IMG.bottle, label:'<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg> FREE with your bundle', qty:1, total:0, was:11.99});
      openCart(); renderCart();
      return;
    }
    var ti = tierSel[id], p = PRODUCTS[id], t = p.tiers[ti];
    var packs = ti + 1; /* the qty picker mirrors the quantity-break: 3 Months Supply <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> qty 3 */
    cart = cart.filter(function(l){ return l.id!==id || !l.fixed; });
    cart.push({key:id+'-tier', id:id, title:p.title, img:p.img, label:t.label+(t.offer?' · '+t.offer:''),
      qty:packs, minQty:packs, unit:t.price/packs, wasU:t.was?t.was/packs:null, total:t.price, fixed:true});
    openCart(); renderCart();
  }
  function cartAddUnit(id){
    var p = PRODUCTS[id], pr = UPSELL_PRICES[id];
    var rate = upsellRate();
    var line = cart.find(function(l){ return l.key===id+'-unit'; });
    if(line){ line.qty++; }
    else cart.push({key:id+'-unit', id:id, title:p.title, img:p.img, label:'', qty:1, unit:upDisc(pr.full,rate), total:upDisc(pr.full,rate), fixed:false});
    if(!document.body.classList.contains('cart-open')) openCart();
    renderCart(); /* renderCart reprices unit lines against the current ladder */
  }
  var MAX_QTY = 15; /* bulk buyers welcome — up to 15 packs per line */
  function cartStep(key,d){
    var line = cart.find(function(l){ return l.key===key; });
    if(!line) return;
    line.qty += d;
    if(line.qty<=0){ cart = cart.filter(function(l){ return l.key!==key; }); }
    else {
      var floor = line.minQty || 1;
      if(line.qty < floor) line.qty = floor;       /* can't go below the quantity-break size — use <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg> to remove */
      if(line.qty > MAX_QTY) line.qty = MAX_QTY;
      if(line.unit!=null) line.total = line.qty*line.unit;
    }
    renderCart();
  }
  function cartRemove(key){
    var line = cart.find(function(l){ return l.key===key; });
    if(line && line.bundle){ cart = cart.filter(function(l){ return l.bundle!==line.bundle; }); } /* a kit removes as one — but only ITS kit */
    else { cart = cart.filter(function(l){ return l.key!==key; }); }
    renderCart();
  }
  /* ---- schema-driven overrides, read from the section's data-ezb-config ---- */
  var EZB_UI = (function(){
    try{
      var r = document.querySelector('[data-ezb-pdp]');
      if(!r) return {};
      var n = r.querySelector('[data-ezb-config]');
      if(!n) return {};
      var c = JSON.parse(n.textContent);
      return (c && c.ui) || {};
    }catch(e){ return {}; }
  })();
  function ezbMergeTiers(target, src){
    if(!src) return target;
    [1,2,3].forEach(function(n){
      var v = src[n] !== undefined ? src[n] : src[String(n)];
      if(!v || typeof v !== 'object' || !target[n]) return;
      Object.keys(v).forEach(function(k){
        var val = v[k];
        if(val === null || val === undefined || val === '') return;
        if(k === 'p' || k === 'w'){
          var f = parseFloat(val);
          if(!isNaN(f)) target[n][k] = f;
        } else {
          target[n][k] = val;
        }
      });
    });
    return target;
  }
  function ezbUiFlavors(list){
    if(!EZB_UI.flavors || !EZB_UI.flavors.length) return list;
    return EZB_UI.flavors.map(function(f, i){
      var d = list[i] || {};
      return { name: f.name || d.name, img: f.img || d.img, tag: f.tag || d.tag };
    });
  }

  /* ==================== FLAVORED PDP BUILDER (functional) ==================== */
  var FLAVORS = [
    {name:'Mango',      img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-1285088.png?v=1785061914'},
    {name:'Lemon',      img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-2192200.png?v=1785061915'},
    {name:'Strawberry', img:'https://cdn.shopify.com/s/files/1/0718/2309/7971/files/energyze-indian-moringa-flavored-100grams-7000996.jpg?v=1785061914'}
  ];
  var FLAV_PRICES = {1:{p:29.99,w:39.99,label:'1 Month Supply'},2:{p:39.99,w:59.98,label:'2 Months Supply'},3:{p:49.97,w:89.97,label:'3 Months Supply'}};
  FLAVORS = ezbUiFlavors(FLAVORS);
  ezbMergeTiers(FLAV_PRICES, EZB_UI.prices && EZB_UI.prices.flav);
  var flavTier = 3, flavSlots = [null,null,null]; /* every picker starts empty — each chooses exactly 1 flavor, any flavor */
  function flavPickTier(el,n){
    flavTier = n;
    el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
    renderFlavSlots();
  }
  /* slot press <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> pop-up with the 3 flavor options; each slot holds exactly 1 choice */
  var flavModalSlot = 0;
  function flavSlotClick(i){
    pickCtx = 'flav'; flavModalSlot = i;
    var current = flavSlots[i];
    document.getElementById('fmTitle').textContent = 'Select your flavor — Slot '+(i+1);
    document.getElementById('fmSub').innerHTML = 'Pick <b>1 of 3</b> for this slot ('+(current?'1':'0')+'/1)';
    var taglines = {Mango:'The bloat-beater', Lemon:'The crisp reset', Strawberry:'The glow-getter'};
    document.getElementById('fmOpts').innerHTML = FLAVORS.map(function(fo){
      return '<div class="fm-opt'+(current===fo.name?' on':'')+'" onclick="flavChoose(\''+fo.name+'\')">'
        +'<img src="'+fo.img+'" alt="'+fo.name+'"><b>'+fo.name+'</b><small>'+taglines[fo.name]+'</small></div>';
    }).join('');
    document.body.classList.add('flav-picking');
  }
  function flavChoose(name){
    if(pickCtx==='bp'){ bSlots[bpModalSlot] = name; flavCloseModal(); renderBpSlots(); return; }
    flavSlots[flavModalSlot] = name;
    flavCloseModal();
    renderFlavSlots();
  }
  function flavCloseModal(){ document.body.classList.remove('flav-picking'); }
  function renderFlavSlots(){
    var wrap = document.getElementById('flavSlots');
    if(!wrap) return;
    wrap.querySelectorAll('.slot').forEach(function(s,i){
      s.style.display = i < flavTier ? 'flex' : 'none';
      var f = flavSlots[i];
      if(f){
        var fo = FLAVORS.find(function(x){ return x.name===f; });
        s.classList.add('filled');
        s.innerHTML = '<img style="width:52px;height:52px;border-radius:11px;object-fit:cover" src="'+fo.img+'" alt="'+f+'"><b>'+f+'</b><span class="slot-progress">1/1 <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5 9 17.5 20 6.5"/></svg> · tap to change</span>';
      } else {
        s.classList.remove('filled');
        s.innerHTML = '<span class="plus">+</span><span style="font-size:.72rem">Select your flavor</span><span class="slot-progress" style="color:var(--text)">0/1</span>';
      }
    });
    var filled = flavSlots.slice(0,flavTier).filter(Boolean).length;
    var btn = document.getElementById('flavAtc');
    if(!btn) return;
    if(filled < flavTier){ btn.disabled = true; btn.textContent = 'Select your flavors ('+filled+'/'+flavTier+')'; }
    else {
      btn.disabled = false;
      var fb = document.getElementById('flavBumpChk');
      var extra = (fb && fb.checked) ? currentBottlePrice() : 0;
      btn.textContent = 'Add '+flavTier+' to Cart — '+fmt(FLAV_PRICES[flavTier].p + extra);
    }
  }
  function flavAtcClick(){
    var btn = document.getElementById('flavAtc');
    if(btn.disabled) return;
    var t = FLAV_PRICES[flavTier];
    cart = cart.filter(function(l){ return l.id!=='flavored' || !l.fixed; });
    /* the cart line's image follows the chosen flavor: all-same <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> that flavor's image, mixed <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> the trio shot */
    var chosen = flavSlots.slice(0,flavTier);
    var distinct = chosen.filter(function(v,i,a){ return a.indexOf(v)===i; });
    var lineImg = distinct.length===1 ? FLAVORS.find(function(f){ return f.name===distinct[0]; }).img : IMG.flavored;
    cart.push({key:'flavored-tier', id:'flavored', title:'Flavored Moringa', img:lineImg,
      label:t.label+' · '+chosen.join(', '), flavors:chosen.slice(),
      qty:flavTier, minQty:flavTier, unit:t.p/flavTier, wasU:t.w?t.w/flavTier:null, total:t.p, fixed:true});
    var fb = document.getElementById('flavBumpChk');
    if(fb && fb.checked) cartAddUnit('bottle'); /* repriced by the ladder once the bag is in */
    openCart(); renderCart();
  }

  /* ==================== UNIFIED PRODUCT GALLERIES ==================== */
  var GAL = {
    flavors: { idx:0, imgs:[
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/IMG_5326.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/IMG_5329.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/CELINE_TOUMA_STRAWBERRY_IMAGE_WITH_REVIEW.jpg' ] },
    original: { idx:0, imgs:[
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Digestion_bundle_main_image.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Moringa_Green_powder_image.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-500-ml-tritan-bottle-1995483.png' ] },
    supergreen: { idx:0, imgs:[
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-super-green-powder-bowl-and-drink-flatlay.png',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Spirulina_blue_powder.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Moringa_Green_powder_image.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-500-ml-tritan-bottle-1995483.png' ] },
    bundles: { idx:0, imgs:[
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/Digestion_bundle_main_image.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/WEBSITEIMAGE_1_1.webp',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-indian-moringa-flavored-100grams-3128727.jpg',
      'https://cdn.shopify.com/s/files/1/0673/9355/2576/files/energyze-500-ml-tritan-bottle-1995483.png' ] }
  };
  function galSet(page,i){
    var g = GAL[page]; if(!g) return;
    g.idx = (i + g.imgs.length) % g.imgs.length;
    var main = document.getElementById('galMain-'+page);
    if(main) main.src = g.imgs[g.idx];
    var wrap = document.getElementById('galThumbs-'+page);
    if(wrap) wrap.querySelectorAll('img').forEach(function(t,j){
      t.classList.toggle('on', j===g.idx);
      if(j===g.idx && t.scrollIntoView) t.scrollIntoView({block:'nearest',inline:'nearest'});
    });
  }
  function galStep(page,d){ galSet(page, GAL[page].idx + d); }
  Object.keys(GAL).forEach(function(page){
    var wrap = document.getElementById('galThumbs-'+page);
    if(!wrap) return;
    wrap.innerHTML = GAL[page].imgs.map(function(u,i){
      return '<img src="'+u+'" alt="View '+(i+1)+'" onclick="galSet(\''+page+'\','+i+')">';
    }).join('');
    galSet(page,0);
  });

  /* ==================== BUNDLE & SAVE BUILDER ==================== */
  /* 1 Bundle = 1 Original + 1 Flavored (choice) + FREE bottle. $50 / $75 / $100. */
  var BP_PRICES = {
    1:{p:50.00, w:61.97, label:'1 Bundle', sub:'1 Original + 1 Flavor + FREE bottle'},
    2:{p:75.00, w:111.95, label:'2 Bundles', offer:'BUY 1 GET THE 2ND 50% OFF', sub:'2 Originals + 2 Flavors + FREE bottle'},
    3:{p:100.00, w:161.93, label:'3 Bundles', offer:'BUY 2 GET 1 FREE', sub:'3 Originals + 3 Flavors + FREE bottle'}
  };
  ezbMergeTiers(BP_PRICES, EZB_UI.prices && EZB_UI.prices.bp);
  var bpTier = 2, bSlots = [null,null,null], bpModalSlot = 0, pickCtx = 'flav';
  function bpPickTier(el,n){
    bpTier = n;
    el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
    renderBpSlots();
  }
  function bpSlotClick(i){
    pickCtx = 'bp'; bpModalSlot = i;
    var current = bSlots[i];
    document.getElementById('fmTitle').textContent = 'Select the flavor for Bundle '+(i+1);
    document.getElementById('fmSub').innerHTML = 'Pick <b>1 of 3</b> for this bundle ('+(current?'1':'0')+'/1)';
    var taglines = {Mango:'The bloat-beater', Lemon:'The crisp reset', Strawberry:'The glow-getter'};
    document.getElementById('fmOpts').innerHTML = FLAVORS.map(function(fo){
      return '<div class="fm-opt'+(current===fo.name?' on':'')+'" onclick="flavChoose(\''+fo.name+'\')">'
        +'<img src="'+fo.img+'" alt="'+fo.name+'"><b>'+fo.name+'</b><small>'+taglines[fo.name]+'</small></div>';
    }).join('');
    document.body.classList.add('flav-picking');
  }
  function renderBpSlots(){
    var wrap = document.getElementById('bpSlots');
    if(!wrap) return;
    wrap.querySelectorAll('.slot').forEach(function(s,i){
      s.style.display = i < bpTier ? 'flex' : 'none';
      var f = bSlots[i];
      if(f){
        var fo = FLAVORS.find(function(x){ return x.name===f; });
        s.classList.add('filled');
        s.innerHTML = '<img style="width:52px;height:52px;border-radius:11px;object-fit:cover" src="'+fo.img+'" alt="'+f+'"><b>'+f+'</b><span class="slot-progress">1/1 <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5 9 17.5 20 6.5"/></svg> · tap to change</span>';
      } else {
        s.classList.remove('filled');
        s.innerHTML = '<span class="plus">+</span><span style="font-size:.72rem">Bundle '+(i+1)+' flavor</span><span class="slot-progress" style="color:var(--text)">0/1</span>';
      }
    });
    var filled = bSlots.slice(0,bpTier).filter(Boolean).length;
    var btn = document.getElementById('bpAtc');
    if(!btn) return;
    if(filled < bpTier){ btn.disabled = true; btn.textContent = 'Select your flavors ('+filled+'/'+bpTier+')'; }
    else { btn.disabled = false; btn.textContent = 'Add '+bpTier+' Bundle'+(bpTier>1?'s':'')+' to Cart — '+fmt(BP_PRICES[bpTier].p); }
  }
  function bpAtcClick(){
    var btn = document.getElementById('bpAtc');
    if(btn.disabled) return;
    var t = BP_PRICES[bpTier];
    cart = cart.filter(function(l){ return l.bundle!=='bp'; });
    var chosen = bSlots.slice(0,bpTier);
    var distinct = chosen.filter(function(v,i,a){ return a.indexOf(v)===i; });
    var lineImg = distinct.length===1 ? FLAVORS.find(function(f){ return f.name===distinct[0]; }).img : IMG.bundle;
    cart.push({key:'bp-tier', id:'bundlekit', bundle:'bp', fixed:true, title:'Original + Flavored Bundle', img:lineImg,
      label:t.label+' · Flavors: '+chosen.join(', ')+' · '+bpTier+'× Original', flavors:chosen.slice(),
      qty:bpTier, minQty:bpTier, unit:t.p/bpTier, wasU:(bpTier>1?49.98:null), total:t.p});
    cart.push({key:'bp-bottle', id:'bottle', bundle:'bp', gift:true, fixed:true, title:'Energyze Shaker Bottle', img:IMG.bottle,
      label:'<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg> FREE with every bundle', qty:1, total:0, was:11.99});
    openCart(); renderCart();
  }

  /* ==================== SUPERGREEN PDP BUILDER ==================== */
  function sgUpdate(){
    var btn = document.getElementById('sgAtc');
    if(!btn) return;
    var bump = document.getElementById('sgBumpChk');
    var total = PRODUCTS.supergreen.tiers[tierSel.supergreen||0].price + (bump && bump.checked ? currentBottlePrice() : 0);
    btn.textContent = 'Add to Cart — ' + fmt(total);
  }
  function sgPickTier(el,n){
    tierSel.supergreen = n-1; /* shares the carousel/cart tier state so everything stays in sync */
    el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
    sgUpdate();
    renderCarousel();
  }
  function sgAtcClick(){
    cartAddTier('supergreen');
    var bump = document.getElementById('sgBumpChk');
    if(bump && bump.checked) cartAddUnit('bottle');
  }

  /* flavor tabs — "The science, simply" section */
  function flavTab(name){
    document.querySelectorAll('.flav-panel').forEach(function(p){ p.classList.toggle('active', p.dataset.flavor===name); });
    document.querySelectorAll('.flav-tab').forEach(function(t){ t.classList.toggle('on', t.dataset.flavor===name); });
  }

  /* quantity-break selection state for UPSELL rows (separate from carousel) */
  var upsellTierSel = {};
  function upsellPickTier(id, i){ upsellTierSel[id] = i; renderCart(); }
  function cartAddUpsell(id){
    var p = PRODUCTS[id];
    var i = upsellTierSel[id] || 0;
    if(p.tiers && p.tiers.length>1 && i>0){ cartSetTier(id, i); }  /* 2M/3M <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> tier line at bundle pricing */
    else { cartAddUnit(id); }                                      /* 1M <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> unit line at upsell pricing */
  }
  /* switch a cart line to another quantity-break tier, right from the drawer */
  function cartSetTier(id, i){
    var p = PRODUCTS[id]; if(!p || !p.tiers || !p.tiers[i]) return;
    var t = p.tiers[i];
    var packs = i + 1; /* qty mirrors the break: switching to 3 Months sets qty 3 */
    cart = cart.filter(function(l){ return l.id!==id; });
    cart.push({key:id+'-tier', id:id, title:p.title, img:p.img, label:t.label+(t.offer?' · '+t.offer:''),
      qty:packs, minQty:packs, unit:t.price/packs, wasU:t.was?t.was/packs:null, total:t.price, fixed:true});
    tierSel[id] = i; renderCarousel();
    renderCart();
  }

  function cartTotalVal(){ return cart.reduce(function(s,l){ return s+l.total; },0); }

  function renderCart(){
    try { localStorage.setItem('ezb_cart', JSON.stringify(cart)); } catch(e) {}
    if (typeof syncRealCart === 'function') syncRealCart();
    var itemsEl = document.getElementById('drawerItems');

    /* -1) recompute fixed-line totals FIRST (qty × pack price) so every rule below sees fresh numbers */
    cart.forEach(function(l){
      if(l.fixed && !l.gift && l.unit!=null){ l.total = l.qty * l.unit; }
    });

    /* 0) FREE BOTTLE consistency rule: every cart with $50+ of bags/kits gets the bottle FREE.
          EXCEPTION — a bundle already contains its own free bottle, so the $50 auto-gift never
          stacks on top of it: the bundle's bottle takes precedence, the auto one is removed. */
    var kitBottle = cart.some(function(l){ return l.id==='bottle' && l.total===0 && l.key!=='free-bottle'; });
    if(kitBottle){ cart = cart.filter(function(l){ return l.key!=='free-bottle'; }); }
    var baseFixed = cart.reduce(function(s,l){ return s + (l.fixed && !l.gift ? l.total : 0); },0);
    var hasFreeBottle = cart.some(function(l){ return l.id==='bottle' && l.total===0; });
    if(baseFixed >= 49.97 && !hasFreeBottle){
      /* if they were PAYING for a bottle, their first bottle becomes the free one */
      var paidBottle = cart.find(function(l){ return l.key==='bottle-unit'; });
      if(paidBottle){
        paidBottle.qty -= 1;
        if(paidBottle.qty<=0) cart = cart.filter(function(l){ return l.key!=='bottle-unit'; });
        else paidBottle.total = paidBottle.qty*paidBottle.unit;
      }
      cart.push({key:'free-bottle', id:'bottle', gift:true, fixed:true, title:'Energyze Shaker Bottle', img:IMG.bottle, label:'<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg> FREE gift — orders $50+', qty:1, total:0, was:11.99});
    }
    if(baseFixed < 49.97){
      cart = cart.filter(function(l){ return l.key!=='free-bottle'; });
    }

    /* 1) reprice upsell unit lines against the current discount ladder (0% / 20% / 30%) */
    var rate = upsellRate();
    cart.forEach(function(l){
      var pr = UPSELL_PRICES[l.id];
      if(!l.fixed && pr){
        l.unit = upDisc(pr.full, rate);
        l.total = l.qty * l.unit;
        l.label = rate>0 ? Math.round(rate*100)+'% upsell discount' : '';
      } else if(l.fixed && !l.gift && l.unit!=null){
        l.total = l.qty * l.unit; /* qty × pack price for multi-pack orders */
      }
    });

    var total = cartTotalVal();
    var disc = total>=100 ? 10 : (total>=60 ? 5 : 0);
    var grand = Math.max(0, total - disc);
    document.getElementById('cartDot').textContent = cart.length;
    document.getElementById('cartCount').textContent = cart.length;
    document.getElementById('cartTotal').textContent = fmt(total);
    var discRow = document.getElementById('discRow');
    discRow.hidden = disc<=0;
    document.getElementById('cartDisc').textContent = '−'+fmt(disc);
    document.getElementById('grandTotal').textContent = fmt(grand);

    /* auto-discount bar */
    var fill = Math.min(total,100);
    document.getElementById('cashFill').style.width = fill+'%';
    document.getElementById('mark60').classList.toggle('hit', total>=60);
    document.getElementById('mark100').classList.toggle('hit', total>=100);
    var msg = document.getElementById('cashMsg'), note = document.getElementById('cashNote');
    if(total<=0){ msg.textContent='Add items to unlock automatic discounts'; note.hidden=true; }
    else if(total<60){ msg.innerHTML='Add <b>'+fmt(60-total)+'</b> more and <b>$5 comes off your bill</b> automatically <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="9" r="6"/><path d="M15.5 4.2A6 6 0 0 1 15.5 20 6 6 0 0 1 9.9 15"/><path d="M7 9h2.2c1 0 1.8.6 1.8 1.5S10.2 12 9.2 12H8m1 0v1.5M9 6v1.5"/></svg>'; note.hidden=true; }
    else if(total<100){ msg.innerHTML='<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20 8.5 8l7.5 7.5L4 20Z"/><path d="M14 6a3 3 0 0 0 3 3M18 2a3 3 0 0 0 3 3M13 3l-.5 1M21 11l-1 .5M20 8h.01M16 12h.01"/></svg> <b>$5 OFF applied!</b> Add <b>'+fmt(100-total)+'</b> more to make it <b>$10 OFF</b>'; note.hidden=false; note.textContent='$5 discount applied — you pay '+fmt(grand)+' instead of '+fmt(total); }
    else { msg.innerHTML='<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20 8.5 8l7.5 7.5L4 20Z"/><path d="M14 6a3 3 0 0 0 3 3M18 2a3 3 0 0 0 3 3M13 3l-.5 1M21 11l-1 .5M20 8h.01M16 12h.01"/></svg><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20 8.5 8l7.5 7.5L4 20Z"/><path d="M14 6a3 3 0 0 0 3 3M18 2a3 3 0 0 0 3 3M13 3l-.5 1M21 11l-1 .5M20 8h.01M16 12h.01"/></svg> <b>$10 OFF applied automatically!</b>'; note.hidden=false; note.textContent='You pay '+fmt(grand)+' instead of '+fmt(total)+' — billed directly at checkout'; }

    /* lines */
    if(!cart.length){
      itemsEl.innerHTML = '<div class="drawer-empty"><p style="font-size:2rem"><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2.2l2.1 12.4a1.6 1.6 0 0 0 1.6 1.3h9.3a1.6 1.6 0 0 0 1.6-1.2L21 7H5.3"/></svg></p><p><b>Your cart is empty.</b></p><p class="muted">Your ritual starts with one scoop.</p></div>';
      return;
    }
    var linesHtml = cart.map(function(l){
      var pr = UPSELL_PRICES[l.id];
      /* compare-at for the line: qty × tier "was", or qty × full price on discounted upsell units */
      var lineWas = l.gift ? l.was
        : l.fixed ? (l.wasU ? l.wasU*l.qty : null)
        : ((pr && rate>0) ? pr.full*l.qty : null);
      var saving = lineWas ? (lineWas - l.total) : 0;
      var steppers = '<div class="dl-qty"><button onclick="cartStep(\''+l.key+'\',-1)">−</button><span>'+l.qty+'</span><button onclick="cartStep(\''+l.key+'\',1)">+</button></div>';
      var qtyHtml = (l.gift || l.bundle)
        ? '<small>'+l.label+'</small>'
        : steppers + (l.label?'<small>'+l.label+'</small>':'');
      var saveHtml = saving>0.009 ? '<small class="dl-save">You save '+fmt(saving)+'</small>' : '';
      /* in-cart quantity-break switcher for products that have tiers (not for bundle kit lines) */
      var tiersHtml = '';
      if(l.key==='bundle-flavored'){
        tiersHtml = '<div class="dl-tiers">'+['Mango','Lemon','Strawberry'].map(function(f){
          return '<span class="dl-tier'+(bundleFlavorSel===f?' on':'')+'" onclick="bundleFlavor(\''+f+'\')">'+f+'</span>';
        }).join('')+'</div>';
      }
      var tp = l.bundle ? null : PRODUCTS[l.id];
      if(tp && tp.tiers && tp.tiers.length>1){
        var curLabel = l.fixed ? (l.label||'').split(' · ')[0] : '';
        tiersHtml = '<div class="dl-tiers">'+tp.tiers.map(function(t,i){
          var onCls = (l.fixed && t.label===curLabel) ? ' on' : '';
          var short = t.label.replace(' Supply','');
          var off = t.was ? Math.round((1 - t.price/t.was)*100) : 0;
          return '<span class="dl-tier'+onCls+'" onclick="cartSetTier(\''+l.id+'\','+i+')">'+short+' '+fmt(t.price)
            +(off?'<span class="t-off">−'+off+'%</span>':'')+'</span>';
        }).join('')+'</div>';
      }
      var priceHtml = l.gift ? '<b style="color:var(--success)">FREE</b>' : fmt(l.total);
      var removeHtml = l.gift ? '' : '<button class="dl-x" onclick="cartRemove(\''+l.key+'\')" aria-label="Remove"><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      return '<div class="dl"><img src="'+l.img+'" alt="">'
        +'<div class="dl-info"><b>'+l.title+'</b>'+qtyHtml+saveHtml+tiersHtml+'</div>'
        +'<span class="dl-price">'+(lineWas?'<span class="dl-was">'+fmt(lineWas)+'</span>':'')+priceHtml+'</span>'
        +removeHtml+'</div>';
    }).join('');

    /* total savings today = product-level savings + the auto cart discount */
    var prodSavings = cart.reduce(function(s,l){
      var pr = UPSELL_PRICES[l.id];
      var w = l.gift ? l.was
        : l.fixed ? (l.wasU ? l.wasU*l.qty : null)
        : ((pr && rate>0) ? pr.full*l.qty : null);
      return s + (w ? (w - l.total) : 0);
    },0);
    var saveNote = document.getElementById('saveNote');
    var totalSave = prodSavings + disc;
    saveNote.hidden = totalSave<=0.009;
    saveNote.innerHTML = 'You\'re saving '+fmt(totalSave)+' today <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20 8.5 8l7.5 7.5L4 20Z"/><path d="M14 6a3 3 0 0 0 3 3M18 2a3 3 0 0 0 3 3M13 3l-.5 1M21 11l-1 .5M20 8h.01M16 12h.01"/></svg>';

    /* metafield-driven upsells: union over cart items' upsell lists, excluding what's in cart */
    var inCart = {};
    cart.forEach(function(l){ inCart[l.id]=true; });
    var seen = {}, ups = [];
    cart.forEach(function(l){
      (UPSELL_METAFIELDS[l.id]||[]).forEach(function(uid){
        if(!inCart[uid] && !seen[uid]){ seen[uid]=true; ups.push(uid); }
      });
    });
    ups = ups.slice(0,3);
    var upsHtml = '';
    if(ups.length){
      upsHtml = '<p class="up-title">Complete your ritual</p>';
      if(rate===0){
        upsHtml += '<p style="font-size:.7rem;font-weight:700;color:var(--text);margin:-.2rem 0 .45rem"><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10.5" width="16" height="10" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 7.9-1"/></svg> Select 1 bag <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> <b>20% OFF</b> add-ons · at $50: <b>30% OFF</b> + FREE bottle <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg></p>';
      } else if(rate===0.20){
        upsHtml += '<p style="font-size:.7rem;font-weight:700;color:var(--success);margin:-.2rem 0 .45rem"><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.5 2.5L16 9.5"/></svg> 20% OFF applied — reach $50 for <b>30% OFF + a FREE bottle <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg></b></p>';
      } else {
        upsHtml += '<p style="font-size:.7rem;font-weight:700;color:var(--success);margin:-.2rem 0 .45rem"><svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.5 2.5L16 9.5"/></svg> 30% OFF add-ons + FREE bottle applied <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg></p>';
      }
      upsHtml += ups.map(function(uid){
        var p = PRODUCTS[uid], pr = UPSELL_PRICES[uid];
        var sub = uid==='bottle' ? p.upsellNote : (PRODUCTS[uid].forLine||'');
        var selIdx = upsellTierSel[uid] || 0;
        var hasTiers = p.tiers && p.tiers.length>1;
        /* price of the SELECTED tier: 1M uses ladder pricing, 2M/3M use bundle tier pricing */
        var priceNow, priceWas, showSave;
        if(hasTiers && selIdx>0){
          var st = p.tiers[selIdx];
          priceNow = st.price; priceWas = st.was||null; showSave = false;
        } else {
          priceNow = upDisc(pr.full, rate);
          priceWas = rate>0 ? pr.full : null;
          showSave = rate>0;
        }
        var savePill = showSave ? ' <span class="pill pill--red" style="font-size:.56rem;padding:1px 7px">SAVE '+Math.round(rate*100)+'%</span>' : '';
        /* quantity-break pills inside the upsell row */
        var tiersHtml = '';
        if(hasTiers){
          tiersHtml = '<div class="dl-tiers">'+p.tiers.map(function(t,i){
            var tPrice, tOff;
            if(i===0){ tPrice = upDisc(pr.full, rate); tOff = Math.round(rate*100); }
            else { tPrice = t.price; tOff = t.was ? Math.round((1 - t.price/t.was)*100) : 0; }
            return '<span class="dl-tier'+(selIdx===i?' on':'')+'" onclick="upsellPickTier(\''+uid+'\','+i+')">'
              +t.label.replace(' Supply','')+' '+fmt(tPrice)
              +(tOff?'<span class="t-off">−'+tOff+'%</span>':'')+'</span>';
          }).join('')+'</div>';
        }
        return '<div class="up-row"><img src="'+p.img+'" alt="">'
          +'<span class="up-info"><b>'+p.title+'</b>'+savePill
          +'<small>'+sub+'</small>'+tiersHtml+'</span>'
          +'<span class="up-price">'+fmt(priceNow)+(priceWas?'<span class="was" style="text-decoration:line-through;color:#9b948d">'+fmt(priceWas)+'</span>':'')+'</span>'
          +'<button class="up-plus" onclick="cartAddUpsell(\''+uid+'\')" aria-label="Add">+</button></div>';
      }).join('');
    }
    itemsEl.innerHTML = linesHtml + upsHtml;
    updatePdpUps(rate);
  }

  /* live prices on the PDP mini upsell cards (flavored AND original pages) */
  function updatePdpUps(rate){
    if(rate===undefined) rate = upsellRate();
    ['bottle','original','supergreen','flavored'].forEach(function(id){
      var full = UPSELL_PRICES[id] ? UPSELL_PRICES[id].full : null;
      if(!full) return;
      document.querySelectorAll('[data-up-price="'+id+'"]').forEach(function(priceEl){
        if(rate>0){ priceEl.innerHTML = fmt(upDisc(full,rate))+'<span class="pu-was">'+fmt(full)+'</span>'; }
        else { priceEl.textContent = fmt(full); }
      });
      document.querySelectorAll('[data-up-pill="'+id+'"]').forEach(function(pillEl){
        if(rate>0){ pillEl.hidden=false; pillEl.textContent='SAVE '+Math.round(rate*100)+'%'; }
        else { pillEl.hidden=true; }
      });
    });
    var hintText = rate===0 ? '<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10.5" width="16" height="10" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 7.9-1"/></svg> Add 1 bag <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> all add-ons drop 20% OFF · at $50: 30% OFF + FREE bottle <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg>'
      : rate===0.20 ? '<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.5 2.5L16 9.5"/></svg> 20% OFF every add-on — reach $50 for 30% OFF + a FREE bottle <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg>'
      : '<svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 2.5 2.5L16 9.5"/></svg> 30% OFF every add-on + FREE bottle in your cart <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7"/><path d="M12 8S10.5 3 8 4.5 9 8 12 8Zm0 0s1.5-5 4-3.5S15 8 12 8Z"/></svg>';
    document.querySelectorAll('.pdp-ups-hint').forEach(function(h){ h.innerHTML = hintText; });
    updateBumps(rate);      /* every bump on the site follows the same trigger */
    origUpdate(); sgUpdate();
    renderFlavSlots();      /* flavored ATC total tracks the bump + ladder too */
  }

  /* ==================== ORIGINAL PDP BUILDER (functional) ==================== */
  var ORIG_PRICES = {1:{p:19.99,w:null,label:'1 Month Supply'},2:{p:24.99,w:39.98,label:'2 Months Supply'},3:{p:29.99,w:59.97,label:'3 Months Supply'}};
  var origTier = 2;
  function currentBottlePrice(){ return upDisc(11.99, upsellRate()); } /* discount ONLY when the cart already qualifies */
  function updateBumps(rate){
    var bp = upDisc(11.99, rate);
    document.querySelectorAll('[data-bump-price]').forEach(function(el){
      el.innerHTML = '+'+fmt(bp)+(rate>0?'<span class="b-was">$11.99</span>':'');
    });
    document.querySelectorAll('[data-bump-pill]').forEach(function(el){
      if(rate>0){ el.hidden=false; el.textContent='SAVE '+Math.round(rate*100)+'%'; } else el.hidden=true;
    });
  }
  function origUpdate(){
    var btn = document.getElementById('origAtc');
    if(!btn) return;
    var bump = document.getElementById('origBumpChk');
    var total = ORIG_PRICES[origTier].p + (bump && bump.checked ? currentBottlePrice() : 0);
    btn.textContent = 'Add to Cart — ' + fmt(total);
  }
  function origPickTier(el,n){
    origTier = n;
    el.parentElement.querySelectorAll('.tier').forEach(function(t){ t.classList.remove('on'); });
    el.classList.add('on');
    origUpdate();
  }
  function origAtcClick(){
    var t = ORIG_PRICES[origTier];
    cart = cart.filter(function(l){ return l.id!=='original' || !l.fixed || l.bundle; });
    cart.push({key:'original-tier', id:'original', title:'Original Powder', img:IMG.original, label:t.label,
      qty:origTier, minQty:origTier, unit:t.p/origTier, wasU:t.w?t.w/origTier:null, total:t.p, fixed:true});
    var bump = document.getElementById('origBumpChk');
    if(bump && bump.checked && !cart.some(function(l){ return l.key==='bottle-unit'; })){
      var pr = UPSELL_PRICES.bottle;
      cart.push({key:'bottle-unit', id:'bottle', title:'Energyze Shaker Bottle', img:IMG.bottle, label:'', qty:1, unit:pr.full, total:pr.full, fixed:false});
    }
    openCart(); renderCart(); /* renderCart reprices the bottle against the ladder automatically */
  }

  function openCart(){ document.body.classList.add('cart-open'); renderCart(); }
  function closeCart(){ document.body.classList.remove('cart-open'); }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeCart(); flavCloseModal(); closeNav(); } });

  /* dropdown menus: click-toggle (touch-friendly), close on outside click */
  document.querySelectorAll('.nav-item').forEach(function(item){
    var trigger = item.querySelector(':scope > a');
    var drop = item.querySelector(':scope > .drop');
    if(!drop) return;
    trigger.addEventListener('click', function(e){
      e.preventDefault();
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.nav-item.open').forEach(function(o){ o.classList.remove('open'); });
      if(!wasOpen) item.classList.add('open');
    });
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('.nav-item')) document.querySelectorAll('.nav-item.open').forEach(function(o){ o.classList.remove('open'); });
  });

  renderCarousel();
  renderCart();
  renderFlavSlots();
  renderBpSlots();

  /* hero background slider + synced review card */
  (function(){
    var slides = document.querySelectorAll('#heroSlides img');
    var dotsWrap = document.getElementById('heroDots');
    var reviewEl = document.getElementById('heroReview');
    if(!slides.length || !dotsWrap) return;
    /* one ANGLE per slide: bloating <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> skincare <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> low-cal & protein <svg class="ei" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg> energy */
    var angles = [
      {h1:'Lose the Bloat.<br>Keep the <em>Energy</em>.',
       review:{stars:'<svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>', quote:'"Bloating gone in 2 weeks"', name:'— Maya K., Verified Buyer'}},
      {h1:'Glow From the <em>Inside Out</em>.',
       review:{stars:'<svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>', quote:'"My skin has honestly never looked better"', name:'— Lea M., Verified Buyer'}},
      {h1:'~12 Calories.<br>Real Plant <em>Protein</em>.',
       review:{stars:'<svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>', quote:'"Swapped my juice — same taste, none of the calories"', name:'— Karim D., Verified Buyer'}},
      {h1:'Clean Energy.<br>Zero <em>Crash</em>.',
       review:{stars:'<svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg><svg class="ei" viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>', quote:'"Replaced my afternoon coffee — no jitters, no crash"', name:'— Omar H., Verified Buyer'}}
    ];
    var idx = 0, timer;
    slides.forEach(function(_,i){
      var b=document.createElement('button');
      if(i===0) b.classList.add('on');
      b.onclick=function(){ show(i); restart(); };
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('button');
    var h1El = document.getElementById('heroH1');
    function show(i){
      idx=i;
      slides.forEach(function(s,j){ s.classList.toggle('on', j===i); });
      dots.forEach(function(d,j){ d.classList.toggle('on', j===i); });
      var a = angles[i];
      if(!a) return;
      if(h1El){
        h1El.style.opacity = 0;
        setTimeout(function(){ h1El.innerHTML = a.h1; h1El.style.opacity = 1; }, 350);
      }
      if(reviewEl){
        reviewEl.classList.add('fade');
        setTimeout(function(){
          reviewEl.innerHTML = '<span class="stars">'+a.review.stars+'</span><b>'+a.review.quote+'</b>'+a.review.name;
          reviewEl.classList.remove('fade');
        }, 350);
      }
    }
    function next(){ show((idx+1)%slides.length); }
    function restart(){ clearInterval(timer); timer=setInterval(next,4500); }
    restart();
  })();
  /* SPA routing: any in-page link like <a href="#flavors"> switches to that store page */
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var h = a.getAttribute('href').slice(1);
    if(!h) return;
    if(PRODUCT_URLS[h]){ e.preventDefault(); window.location.href = PRODUCT_URLS[h]; return; }
    if(h==='home' || document.getElementById('page-'+h)){ e.preventDefault(); location.hash = h; go(h); }
  });
  window.addEventListener('hashchange', function(){ go((location.hash||'#home').replace('#','')); });
  go((location.hash||'#home').replace('#',''));

/* ==================== REAL SHOPIFY CHECKOUT ==================== */
function ezbVariants(){
  try { return JSON.parse(document.getElementById('ezb-variants').textContent); } catch(e){ return null; }
}
function ezbFlavorVariant(V, name){
  if(!V || !V.flavored) return null;
  var keys = Object.keys(V.flavored);
  for(var i=0;i<keys.length;i++){ if(name && keys[i].toLowerCase().indexOf(name.toLowerCase())>-1) return V.flavored[keys[i]]; }
  return keys.length ? V.flavored[keys[0]] : null;
}
function cartToItems(V){
  var items = {}; /* variantId -> qty */
  function add(vid, q){ if(!vid || q<=0) return; items[vid] = (items[vid]||0) + q; }
  cart.forEach(function(l){
    if(l.id==='flavored'){
      if(l.flavors && l.flavors.length){
        var per = Math.max(1, Math.round(l.qty / l.flavors.length));
        l.flavors.forEach(function(f){ add(ezbFlavorVariant(V, f), per); });
      } else { add(ezbFlavorVariant(V, null), l.qty); }
    } else if(l.id==='original'){ add(V.original, l.qty); }
    else if(l.id==='supergreen'){ add(V.supergreen, l.qty); }
    else if(l.id==='bottle'){
      /* A gift bottle must map to the $0.00 gift product. This store has no
         'gift-energyze-bottle' product (it exists on the Lebanon store this theme was
         cloned from), so V.giftbottle is null. Falling back to the paid bottle charged
         $11.99 for something the buy box advertises as FREE: the 3-pack button read
         $49.97 and the cart came to $56.96. Skip the line instead of charging for
         a gift. Create a $0.00 gift bottle product to restore the perk. */
      if(l.gift || l.total===0){ if(V.giftbottle) add(V.giftbottle, l.qty); }
      else add(V.bottle, l.qty);
    }
    else if(l.id==='bundlekit'){
      add(V.original, l.qty);
      if(l.flavors && l.flavors.length){ l.flavors.forEach(function(f){ add(ezbFlavorVariant(V, f), 1); }); }
      else { add(ezbFlavorVariant(V, null), l.qty); }
    }
  });
  return items;
}
/* DISABLED. This cleared the real Shopify cart and re-added this file's in-memory
   drawer model 700ms after any render. Since that model persists in
   localStorage['ezb_cart'], stale lines were resurrected on every add and could not be
   removed: deleting a line in the drawer changed only the Shopify cart, and the next
   sync put it straight back. That is how a cart ended up with 6 Original and
   3 Supergreen attached to every order.

   The real Shopify cart is now authoritative. blueprint.js posts adds to /cart/add.js
   (its drawerReady() is forced false) and ezb-cart.js renders and mutates /cart.js
   directly. Kept as a no-op rather than deleted because renderCart() still calls it. */
var ezbSyncTimer = null;
function syncRealCart(){
  return;
}
function ezbCheckout(){
  var V = ezbVariants();
  if(!V){ window.location.href='/cart'; return; }
  var items = cartToItems(V);
  var parts = Object.keys(items).map(function(vid){ return vid + ':' + items[vid]; });
  if(!parts.length) return;
  window.location.href = '/cart/' + parts.join(',');
}

/* ==================== QUICK-SHOP CARD ENGINE (Liquid product blocks) ==================== */
var RIT_ENGINE = {
  'energyze-moringa-flavored-powder-100g': 'flavored',
  'energyze-moringa-powder-original': 'original',
  'energyze-supergreen': 'supergreen',
  'energyze-500-ml-plastic-pba-bottles': 'bottle',
  'the-all-in-bundle-3-flavors-available': 'bundle'
};
function ritVarPick(el){
  el.parentElement.querySelectorAll('.dl-tier').forEach(function(t){ t.classList.remove('on'); });
  el.classList.add('on');
}
function ritQbPick(el){
  if(el.classList.contains('sold-out')) return;
  el.parentElement.querySelectorAll('.qb-row').forEach(function(r){ r.classList.remove('on'); });
  el.classList.add('on');
  var card = el.closest('.rit-card');
  var btn = card && card.querySelector('.rit-atc');
  if(btn){
    if(!btn.dataset.baseLabel) btn.dataset.baseLabel = btn.textContent.split(' — ')[0].trim();
    var price = parseFloat(el.dataset.price);
    btn.textContent = isNaN(price) ? btn.dataset.baseLabel : btn.dataset.baseLabel + ' — ' + fmt(price);
  }
  ritRenderSlots(card);
}

/* Render one variant picker per pack INSIDE the selected quantity-break tier (mirrors the Flavored PDP) */
function ritRenderSlots(card){
  if(!card) return;
  var wrap = card.querySelector('[data-rv]');
  if(!wrap) return;
  var variants;
  try { variants = JSON.parse(wrap.dataset.variants || '[]'); } catch(e){ variants = []; }
  if(!variants.length) return;
  var row = card.querySelector('.qb-row.on') || card.querySelector('.qb-row');
  if(!row) return;
  /* clear pickers from every tier, then build inside the active one */
  card.querySelectorAll('[data-rv-row]').forEach(function(h){ h.innerHTML = ''; });
  var host = row.querySelector('[data-rv-row]');
  if(!host) return;
  var qty = parseInt(row.dataset.qty, 10) || 1;
  var prev = (wrap.dataset.picked || '').split('|').filter(Boolean);
  var label = wrap.dataset.label || 'Choose your flavor';
  var html = '<p class="rv-head">' + label + (qty > 1 ? ' — ' + qty + ' packs' : '') + '</p>';
  for(var i = 0; i < qty; i++){
    var chosen = prev[i] || (variants.find(function(v){ return v.available; }) || variants[0]).id;
    html += '<div class="rv-slot" data-slot="' + i + '">';
    if(qty > 1) html += '<span class="rv-num">#' + (i+1) + '</span>';
    variants.forEach(function(v){
      html += '<button type="button" class="rv-pill' + (String(v.id) === String(chosen) ? ' on' : '') +
              (v.available ? '' : ' disabled') + '" data-vid="' + v.id + '" onclick="ritSlotPick(this);event.stopPropagation()">' +
              '<span class="rv-cir">' + v.title.charAt(0).toUpperCase() + '</span>' +
              '<span class="rv-name">' + v.title + '</span></button>';
    });
    html += '</div>';
  }
  host.innerHTML = html;
  ritSyncPicked(card);
}
function ritSlotPick(btn){
  var slot = btn.closest('.rv-slot');
  slot.querySelectorAll('.rv-pill').forEach(function(p){ p.classList.remove('on'); });
  btn.classList.add('on');
  ritSyncPicked(btn.closest('.rit-card'));
}
function ritSyncPicked(card){
  var wrap = card && card.querySelector('[data-rv]');
  if(!wrap) return;
  var picked = [];
  card.querySelectorAll('.rv-slot').forEach(function(s){
    var on = s.querySelector('.rv-pill.on');
    if(on) picked.push(on.dataset.vid);
  });
  wrap.dataset.picked = picked.join('|');
}
function ritCardAdd(btn){
  var card = btn.closest('.rit-card');
  if(!card) return;

  /* Real Shopify add-to-cart. Quantity break = how many packs; variant slots = which flavor per pack. */
  var selRow = card.querySelector('.qb-row.on') || card.querySelector('.qb-row');
  var qty = selRow ? (parseInt(selRow.dataset.qty, 10) || 1) : 1;
  var rvWrap = card.querySelector('[data-rv]');
  var items = [];
  if(rvWrap && (rvWrap.dataset.picked || '').length){
    /* group identical variants so the cart shows tidy line items */
    var counts = {};
    rvWrap.dataset.picked.split('|').filter(Boolean).forEach(function(id){ counts[id] = (counts[id] || 0) + 1; });
    Object.keys(counts).forEach(function(id){ items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
  } else {
    var vid = (selRow && selRow.dataset.vid) || card.dataset.vid;
    if(vid) items.push({ id: parseInt(vid, 10), quantity: qty });
  }
  if(items.length){
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ items: items })
    }).then(function(r){
      btn.disabled = false;
      if(r.ok){
        btn.textContent = original;
        /* Success handler is isolated: if the drawer refresh throws, the add still
           succeeded, so never bounce the customer off the page. */
        try { if(window.ezbCartAdded) ezbCartAdded(); else window.location.href = '/cart'; }
        catch(e){ window.location.href = '/cart'; }
        return;
      }
      /* Not OK: surface Shopify's real reason instead of a blanket "Sold out".
         A 422 here usually means the requested quantity plus what is already in the
         cart exceeds available stock -- not that the product is unavailable. */
      return r.json().catch(function(){ return {}; }).then(function(b){
        var msg = (b && (b.description || b.message)) || '';
        var label = 'Try again';
        if(r.status === 422){
          label = /can add|already|only have|items? in your cart/i.test(msg) ? 'Max in cart' : 'Sold out';
        }
        btn.textContent = label;
        if(msg) { try { console.warn('[cart] ' + r.status + ': ' + msg); } catch(e){} }
        setTimeout(function(){ btn.textContent = original; }, 2600);
      });
    }).catch(function(){
      /* Network/throttle failure only -- keep the customer where they are. */
      btn.disabled = false; btn.textContent = 'Try again';
      setTimeout(function(){ btn.textContent = original; }, 2600);
    });
    return;
  }

  /* Fallback: demo cart engine (no product assigned) */
  var handle = card.dataset.handle || '';
  var eid = RIT_ENGINE[handle];
  if(eid === 'bundle'){ cartAddTier('bundle'); return; }
  if(!eid){ window.location.href = card.dataset.url || '/'; return; }
  var row = card.querySelector('.qb-row.on') || card.querySelector('.qb-row');
  var packs = row ? (parseInt(row.dataset.qty,10) || 1) : 1;
  var price = row ? parseFloat(row.dataset.price) : parseFloat(card.dataset.price);
  if(isNaN(price)) price = 0;
  var was = row ? parseFloat(row.dataset.was) : NaN;
  var label = row ? (row.dataset.label || '') : '';
  var vEl = card.querySelector('.rit-vars .dl-tier.on');
  var flavor = vEl ? vEl.dataset.vtitle : null;
  cart = cart.filter(function(l){ return l.id!==eid || !l.fixed; });
  var line = {key:eid+'-tier', id:eid, title:card.dataset.title || (PRODUCTS[eid] && PRODUCTS[eid].title) || handle,
    img:card.dataset.img || (PRODUCTS[eid] && PRODUCTS[eid].img) || '',
    label:label + (flavor ? ' · ' + flavor : ''),
    qty:packs, minQty:packs, unit:price/packs, wasU:(!isNaN(was) && was>0) ? was/packs : null, total:price, fixed:true};
  if(flavor){ line.flavors = []; for(var i=0;i<packs;i++) line.flavors.push(flavor); }
  cart.push(line);
  tierSel[eid] = packs - 1;
  openCart(); renderCart();
}

/* ==================== CARD CLICK-THROUGH ====================
   Anywhere on a homepage product card (except its buttons, links and
   pickers) navigates to that product's landing page. The Add to Cart
   button and every tier / flavor picker keep their own behavior. */
document.addEventListener('click', function(e){
  var card = e.target.closest && e.target.closest('.rit-card');
  if(!card) return;
  if(e.target.closest('button, a, .qb-row, .rv-pill, .rv-slot, .dl-tier, input, select, label')) return;
  var url = card.dataset.url;
  if(!url){
    var a = card.querySelector('a[href]');
    url = a && a.getAttribute('href');
  }
  if(url) window.location.href = url;
});
